import { ArrowRight } from "lucide-react";
import { formatPrice, steps } from "../data";
import { calculatePrice } from "../pricing";
import { validateConfiguration } from "../rules";
import { useConfiguratorStore } from "../store";

export function MobileActionBar({ onQuote }: { onQuote: () => void }) {
  const configuration = useConfiguratorStore((state) => state.configuration);
  const step = useConfiguratorStore((state) => state.step);
  const setStep = useConfiguratorStore((state) => state.setStep);
  const price = calculatePrice(configuration);
  const rules = validateConfiguration(configuration);
  const index = steps.findIndex((item) => item.id === step);
  const isLast = index === steps.length - 1;

  return (
    <div className="mobile-action-bar">
      <div>
        <small>Estimeret pris</small>
        <strong>{formatPrice(price.total)}</strong>
      </div>
      <button
        className="button button-primary"
        type="button"
        disabled={!rules.valid}
        onClick={() => isLast ? onQuote() : setStep(steps[index + 1].id)}
      >
        {isLast ? "Få tilbud" : "Fortsæt"}
        <ArrowRight size={16} />
      </button>
    </div>
  );
}
